// packages/ui/src/tools/useToolContributionsFor.ts
import { useSyncExternalStore } from 'react';
import type { ToolContributions } from '@slate/core';
import { ToolRegistry } from './ToolRegistry';

export function useToolContributionsFor<K extends keyof ToolContributions>(
  point: K,
): NonNullable<ToolContributions[K]> {
  return useSyncExternalStore(
    (cb) => ToolRegistry.subscribe(cb),
    () => ToolRegistry.contributionsFor(point),
    () => ToolRegistry.contributionsFor(point),
  );
}
